import { Stack } from '@mui/material'
import EmpresasComponent from '../components/Empresas/EmpresasComponent'
import Header from '../components/Header/Header'

export default function Empresas() {
  return (
    <>
      <Header />
      <Stack direction='column' padding={'100px'} alignItems='flex-start' justifyContent='flex-start'>
        <EmpresasComponent />
      </Stack>
    </>
  )
}
